import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    strategyData: {},
    metaData: {},
};
export const strategyReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.STRATEGY.APPLY_STRATEGY: {
                const { strategyData = {}, listing = {}, metaData = {} } = payload
                return {
                    ...state,
                    listing, strategyData,
                    metaData
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default strategyReducer;
